import type { ArtworkLayer } from "../types";

interface Props {
  layers: ArtworkLayer[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onToggleVisible: (id: string) => void;
  onReorder: (id: string, dir: "up" | "down") => void;
  onRemove: (id: string) => void;
}

export function LayerList({
  layers,
  selectedId,
  onSelect,
  onToggleVisible,
  onReorder,
  onRemove,
}: Props) {
  if (layers.length === 0) {
    return <div className="layer-empty">No layers yet. Drop or upload an image.</div>;
  }

  // Render from topmost (drawn last) to bottommost for intuitive stacking.
  const rendered = [...layers].reverse();

  return (
    <ul className="layer-list">
      {rendered.map((l) => (
        <li
          key={l.id}
          className={`layer-item ${selectedId === l.id ? "selected" : ""}`}
          onClick={() => onSelect(l.id)}
        >
          <span className={`layer-dot side-${l.side}`} title={l.side} />
          <span className="layer-name" title={l.name}>
            {l.name}
          </span>
          <div className="layer-actions" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="icon-btn"
              onClick={() => onReorder(l.id, "up")}
              title="Bring forward"
            >
              ▲
            </button>
            <button
              type="button"
              className="icon-btn"
              onClick={() => onReorder(l.id, "down")}
              title="Send backward"
            >
              ▼
            </button>
            <button
              type="button"
              className="icon-btn"
              onClick={() => onToggleVisible(l.id)}
              title={l.visible ? "Hide" : "Show"}
            >
              {l.visible ? "👁" : "🚫"}
            </button>
            <button
              type="button"
              className="icon-btn danger"
              onClick={() => onRemove(l.id)}
              title="Delete"
            >
              ✕
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
}
